import { MessageSquareText, Sparkles, Target, CircleCheck, Copy, Pencil } from "lucide-react";
import copy from "@/content/homepage-copy.json";

const STEP_ICONS = [MessageSquareText, Sparkles, Target];

// Poglądowa makieta „Stwórz prompt" (HTML/CSS, nie bitmapa). Treść z homepage-copy.json.
export const PromptBuilderMockup = () => {
  const b = copy.hero.builder;

  const StepIcon = ({ i }) => {
    const Icon = STEP_ICONS[i];
    return (
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-field border border-brand-line bg-brand-elevated text-brand-accent">
        <Icon size={16} strokeWidth={1.75} aria-hidden="true" />
      </div>
    );
  };

  const Chip = ({ label, active }) => (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[12px] font-medium transition-colors ${
        active
          ? "bg-brand-accent text-brand-on"
          : "border border-brand-line text-brand-sec"
      }`}
    >
      {active && <CircleCheck size={13} strokeWidth={2.25} aria-hidden="true" />}
      {label}
    </span>
  );

  return (
    <div
      className="relative w-full overflow-hidden rounded-panel border border-brand-line bg-brand-surface accent-glow"
      role="img"
      aria-label="Poglądowa makieta kreatora promptu Promptivo"
      data-testid="prompt-builder-mockup"
    >
      {/* header */}
      <div className="border-b border-brand-line px-5 py-4">
        <span className="font-display text-base font-semibold text-brand-text">{b.title}</span>
      </div>

      <div className="space-y-3 p-4 sm:p-5">
        {/* step 1 */}
        <div className="flex items-start gap-3">
          <StepIcon i={0} />
          <div className="min-w-0 flex-1 rounded-field border border-brand-line bg-brand-elevated/40 px-4 py-3">
            <p className="text-[11px] font-medium text-brand-muted">{b.step1Label}</p>
            <p className="mt-1 text-[13px] font-medium text-brand-text">{b.step1Value}</p>
          </div>
        </div>

        {/* step 2 */}
        <div className="flex items-start gap-3">
          <StepIcon i={1} />
          <div className="min-w-0 flex-1 rounded-field border border-brand-line bg-brand-elevated/40 px-4 py-3">
            <p className="text-[11px] font-medium text-brand-muted">{b.step2Label}</p>
            <div className="mt-2 flex flex-wrap gap-2">
              {b.step2Options.map((o, i) => (
                <Chip key={o} label={o} active={i === 0} />
              ))}
            </div>
          </div>
        </div>

        {/* step 3 */}
        <div className="flex items-start gap-3">
          <StepIcon i={2} />
          <div className="min-w-0 flex-1 rounded-field border border-brand-line bg-brand-elevated/40 px-4 py-3">
            <p className="text-[11px] font-medium text-brand-muted">{b.step3Label}</p>
            <div className="mt-2 flex flex-wrap gap-2">
              {b.step3Options.map((o, i) => (
                <Chip key={o} label={o} active={i === 0} />
              ))}
            </div>
          </div>
        </div>

        {/* result */}
        <div className="rounded-panel border border-brand-accent/50 bg-brand-accent/[0.05] p-4 accent-glow">
          <div className="flex items-center gap-2">
            <CircleCheck size={17} strokeWidth={2} className="text-brand-accent" aria-hidden="true" />
            <span className="font-display text-sm font-semibold text-brand-accent">{b.resultLabel}</span>
          </div>
          <p className="mt-2.5 text-[12.5px] leading-[1.6] text-brand-sec">{b.resultText}</p>
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-1.5 rounded-field bg-brand-accent px-4 py-2 text-[12px] font-semibold text-brand-on">
              <Copy size={13} strokeWidth={2} aria-hidden="true" />
              {b.copyLabel}
            </span>
            <span className="inline-flex items-center gap-1.5 text-[12px] font-medium text-brand-sec">
              <Pencil size={13} strokeWidth={1.75} aria-hidden="true" />
              {b.editLabel}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
